export const DTCC_TRANSFER_TYPES = [
  "FUL",
  "FRV",
  "MFC",
  "PTD",
  "PTR",
  "RCL",
  "RCR",
  "PTF",
] as const;

export type DtccTransferType = (typeof DTCC_TRANSFER_TYPES)[number];

export const TRANSFER_DIRECTIONS = ["INCOMING", "OUTGOING"] as const;

export type TransferDirection = (typeof TRANSFER_DIRECTIONS)[number];

export const ALPACA_TRANSFER_STATUSES = [
  "PENDING",
  "IN_PROGRESS",
  "REJECTED",
  "SETTLED",
] as const;

export type AlpacaTransferStatus = (typeof ALPACA_TRANSFER_STATUSES)[number];

export const DTCC_TRANSFER_STATUSES = [
  "REQUEST",
  "REQUEST_ADJUST",
  "REQUEST_ADJUST_PAST",
  "REQUEST_PAST",
  "REQUEST_REJECT",
  "REVIEW",
  "REVIEW_ADJUST_DELIVERER",
  "REVIEW_ERROR",
  "REVIEW_ACCELERATE",
  "REVIEW_ADJUST_RECEIVER_ACCELERATE",
  "SETTLE_PREP",
  "SETTLE_CLOSE",
  "CLOSE_PURGE",
  "REQUEST_PTR",
  "MEMO_PURGE_PARTIAL_TRANSFER_REQUEST_RECEIVER",
  "REJECT",
] as const;

export type DtccTransferStatus = (typeof DTCC_TRANSFER_STATUSES)[number];

export const DTCC_REJECTION_REASONS = [
  "SS_TAX_ID_MISMATCH",
  "ACCOUNT_TITLE_MISMATCH",
  "DOCUMENTATION_NEEDED",
  "ACCOUNT_FLAT",
  "INVALID_ACCOUNT_NUMBER",
  "DUPLICATE",
  "ACCOUNT_IN_DISTRIBUTION_OR_TRANSFER",
  "CLIENT_RESCINDED",
  "MISSING_AUTHORIZATION_SIGNATURE",
  "ACCOUNT_VIOLATES_CREDIT_POLICY_OF_RECEIVING_FIRM",
  "UNRECOGNIZED_FOR_RESIDUAL_CREDIT_BALANCE",
  "PARTIAL_TRANSFER_DELIVERER_INITIATED_REJECT",
  "FAIL_REVERSAL_REJECT",
  "RECLAIM_REJECT",
  "MUTUAL_FUND_CLEANUP",
  "SYSTEM_REJECTED",
] as const;

export type DtccRejectionReason = (typeof DTCC_REJECTION_REASONS)[number];

export const CONTRA_BROKER_TYPES = ["BANK", "BROKER"] as const;

export type ContraBrokerType = (typeof CONTRA_BROKER_TYPES)[number];

export const DTCC_ACCOUNT_TYPES = [
  "AGENCY",
  "BANK_CUSTODY",
  "BENEFICIARY",
  "BENEFICIARY_ROTH_IRA",
  "CORPORATE",
  "CO_TRUSTEE",
  "COVERDELL_IRA",
  "CUSTODIAN_UGMA",
  "DIRECT_ROLLOVER",
  "ESTATE",
  "HSA",
  "IRA",
  "JOINT",
  "MEDICAL_SAVINGS_ACCOUNT",
  "OTHER",
  "QUALIFIED_OR_PROFIT_SHARING_OR_PENSION",
  "ROTH_401K",
  "ROTH_IRA",
  "ROTH_SEP",
  "ROTH_SIMPLE",
  "ROTH_SOLO_401K",
  "SARSEP",
  "SEP_IRA",
  "SIMPLE_IRA",
  "SINGLE",
  "SOLO_401K",
  "TRUST",
  "TYPE_401K",
  "TYPE_403B",
  "TYPE_457_PLAN",
  "TYPE_529_PLAN",
] as const;

export type DtccAccountType = (typeof DTCC_ACCOUNT_TYPES)[number];

export const ACATS_ASSET_CLASSES = [
  "EQUITY",
  "CASH",
  "OPTION",
  "OTHER",
] as const;

export type AcatsAssetClass = (typeof ACATS_ASSET_CLASSES)[number];

export const ACATS_ASSET_STATUSES = [
  "NOT_VALIDATED",
  "REQUESTED",
  "DELETED",
  "SETTLED",
  "REVERSED",
  "INTERFACE_REJECTED",
] as const;

export type AcatsAssetStatus = (typeof ACATS_ASSET_STATUSES)[number];

export const ACATS_ASSET_POSITIONS = ["LONG", "SHORT"] as const;

export type AcatsAssetPosition = (typeof ACATS_ASSET_POSITIONS)[number];

export const CONTRA_TRANSFER_TYPES = ["FULL", "PARTIAL"] as const;

export type ContraTransferType = (typeof CONTRA_TRANSFER_TYPES)[number];
